import { render, staticRenderFns } from "./JcDialog.vue?vue&type=template&id=fdd7b4e4&scoped=true&"
import script from "./JcDialog.vue?vue&type=script&lang=js&"
export * from "./JcDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd7b4e4",
  null
  
)

export default component.exports